import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BeratungWatchRecordingPageRoutingModule } from './beratung-watch-recording-routing.module';

import { BeratungWatchRecordingPage } from './beratung-watch-recording.page';
import { HeaderModule } from 'src/app/components/header/header.module';
import { VideoPlayerModule } from 'src/app/components/video-player/video-player.module';
import { BackButtonModule } from 'src/app/components/back-button/back-button.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BeratungWatchRecordingPageRoutingModule,
    HeaderModule,
    VideoPlayerModule,
    BackButtonModule,
  ],
  declarations: [BeratungWatchRecordingPage]
})
export class BeratungWatchRecordingPageModule {}
